import * as api from '../../services/feedback'

export const FETCH_FEEDBACKS= 'FETCH_FEEDBACKS';
export const FETCH_FEEDBACK = 'FETCH_FEEDBACK';
export const FETCH_EVTFEEDBACKS = 'FETCH_EVTFEEDBACKS';


export const fetchFeedback = (id) => ({
    type: FETCH_FEEDBACK,
    payload: {
        promise: api.findFeedback({id: id})
    }
});


export const fetchFeedbacks = (params, pagination, sort, extra) => {

    return {
        type: FETCH_FEEDBACKS,
        payload: {
            promise: api.findFeedbacks(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchEvtFeedbacks = (params, pagination, sort, extra) => {

    return {
        type: FETCH_EVTFEEDBACKS,
        payload: {
            promise: api.findEvtFeedbacks(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/feedback.js